import { useState, useEffect } from 'react';
import axios from 'axios';

export const LOGIN_BG_PADRAO = 'https://customer-assets-v7afamib.emergentagent.net/job_b9b95699-8587-4dd0-86fd-44f181259c37/artifacts/3eo4pwky_photo_5181552106605841706_y.jpg';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const useLoginImagem = () => {
  const [url, setUrl] = useState(LOGIN_BG_PADRAO);
  useEffect(() => {
    axios.get(`${BACKEND_URL}/api/aparencia/login`)
      .then((res) => { if (res.data?.imagem_url) setUrl(`${BACKEND_URL}${res.data.imagem_url}`); })
      .catch(() => {});
  }, []);
  return url;
};
